import React from "react";
import ReactDOM from "react-dom/client";
import { Layout } from "@children/layout.jsx";
import * as Sentry from "@sentry/react";

const el = document.getElementById("react-app");

if (window.sentryDsn) {
  Sentry.init({
    dsn: window.sentryDsn,
    environment: "production",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1,
    sendDefaultPii: true,
  });
}

if (el) {
  ReactDOM.createRoot(el).render(
    // <DevSupport ComponentPreviews={ComponentPreviews} useInitialHook={useInitial}>
    <Layout />
    // </DevSupport>
  );
}
